interface ScoreMeterProps {
  scorePercentage: number;
}

export const ScoreMeter = ({ scorePercentage }: ScoreMeterProps) => {
  return (
    <div className="relative flex items-center justify-center">
      <div className="absolute w-[97%] h-[75%]">
        {scorePercentage !== 0 && <div style={{ width: `${scorePercentage}%` }} className="h-full bg-clearMeter animate-score-meter" />}
      </div>
      <img className="w-full z-10" src={`/common/score_meter_frame.webp`} alt={'クリアメーター'} />
      {scorePercentage === 100 && (
        <img className="absolute w-[25%] mt-[2%] animate-clear-on-meter" src={`/common/clear_on_score_meter.webp`} alt={'クリア'} />
      )}
    </div>
  );
};
